'use es6';

export const getRootUrl = () => '/khoros/integration';